import React, {useState, useRef} from 'react';
import './FAQForm.css';
import {Button, TextField} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import FAQManager from "./FaqManager";
import axios from "axios";
import JoditEditor from "jodit-react";

function FAQForm() {
    const editorGe = useRef(null);
    const editorEn = useRef(null);
    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const configGeo = {
        placeholder: "ტექსტი ქართულად...",
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 400,
        width: 1100,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };

    const configEng = {
        placeholder: "ტექსტი ინგლისურად...",
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        height: 400,
        width: 1100,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'link',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    };
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        titleEng: '',
        descriptionEng: '',
    });

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState({open: false, message: '', type: ''});
    const [updateKey, setUpdateKey] = useState(0);

    const handleChange = (event) => {
        setFormData({...formData, [event.target.name]: event.target.value});
    };

    const showCustomAlert = (message, type) => {
        setAlertInfo({open: true, message, type});
    };

    const handleFormSubmit = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewFAQ`, formData, {
                headers: {'Content-Type': 'application/json'}
            });

            if (response.status === 200) {
                setUpdateKey(prev => prev + 1);
                showCustomAlert('ოპერაცია წარმატებით დასრულდა', 'success');
                setFormData({
                    title: '',
                    description: '',
                    titleEng: '',
                    descriptionEng: '',
                });
            } else {
                showCustomAlert('დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით!', 'error');
            }
        } catch {
            showCustomAlert('Error during submission!', 'error');
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsModalOpen(true);
    };

    const handleConfirm = () => {
        setIsModalOpen(false);
        handleFormSubmit();
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const isFormIncomplete = formData.title.trim() === '' || formData.titleEng.trim() === '' ||
        formData.description.trim() === '' || formData.descriptionEng.trim() === '';

    return (
        <div className="faq-container">
            <h1 className="employee-form-title">კითხვების დამატება</h1>
            <form className="faq-form" onSubmit={handleSubmit}>
                <TextField
                    label="კითხვა"
                    variant="outlined"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    margin="normal"
                />
                <div className="editor-wrapper">
                    <JoditEditor
                        ref={editorGe}
                        config={configGeo}
                        value={formData.description}
                        onBlur={(value) => setFormData({...formData, description: value})}
                        style={{width: '800px', height: '400px'}}
                    />
                </div>
                <TextField
                    label="კითხვა (ინგლისურად)"
                    variant="outlined"
                    name="titleEng"
                    value={formData.titleEng}
                    onChange={handleChange}
                    margin="normal"
                />
                <div className="editor-wrapper">
                    <JoditEditor
                        ref={editorEn}
                        config={configEng}
                        value={formData.descriptionEng}
                        onBlur={(value) => setFormData({...formData, descriptionEng: value})}
                        style={{width: '800px', height: '400px'}}
                    />
                </div>
                <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    className="submitButton"
                    disabled={isFormIncomplete}
                >
                    დამატება
                </Button>
            </form>

            <FAQManager updateKey={updateKey} />
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={handleCloseModal}
                onConfirm={handleConfirm}
            />
            {alertInfo.open && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={() => setAlertInfo({open: false, message: '', type: ''})}
                />
            )}
        </div>
    );
}

export default FAQForm;
